import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const CarouselFeature = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      className="flex flex-col items-center text-center"
    >
      {/* Icon */}
      {blok.icon?.filename && (
        <img
          src={blok.icon.filename}
          alt={blok.icon.alt || ""}
          className="w-10 h-10 mb-2"
        />
      )}

      {/* Title */}
      {blok.title && (
        <h4 className="font-semibold text-[#00033E] text-sm mb-1">
          {blok.title}
        </h4>
      )}

      {/* Description */}
      {blok.description && (
        <div className="text-[#00033E] text-xs opacity-80 leading-relaxed">
          {typeof blok.description === "string"
            ? blok.description
            : customRenderRichText(blok.description)}
        </div>
      )}
    </div>
  );
};

export default CarouselFeature;
